import { Window } from '@execonline-inc/browser-window.private';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';
import Title from '../../Title';
import { ErrorPageBackground } from '../common/ErrorPageBackground';
import logo from '../../assets/error-page/logo.svg';
import illustration from '../../assets/error-page/illustration.svg';

const SSOAccessEnded: React.FC<{}> = observer(() => {
  const handleVisitWebsite = () => {
    Window.redirect('https://www.execonline.com');
  };

  return (
    <div className="relative h-screen w-full overflow-hidden bg-[#fafafa]">
      <Title title="Access Ended" />
      <ErrorPageBackground />

      {/* Header */}
      <header
        className="absolute left-0 top-0 z-50 flex w-full items-center justify-between bg-white px-4 py-3 md:px-12 md:py-4"
        data-intercom-target="sso-access-ended-header"
        style={{ borderBottom: '1px solid #e5e5e5' }}
      >
        <div className="flex items-center gap-8 md:gap-16">
          <a
            href="https://www.execonline.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block h-[18px] w-[110px] md:h-[23.333px] md:w-[140px]"
          >
            <img src={logo} alt="ExecOnline" className="block h-full w-full" />
          </a>
        </div>
      </header>

      {/* Main content */}
      <div className="relative z-0 flex h-full flex-col items-center justify-center px-4 pt-16 md:px-0 md:pt-16">
        {/* Illustration */}
        <div className="mb-6 flex items-center justify-center md:mb-8">
          <img
            src={illustration}
            alt="Disconnected servers illustration"
            className="max-h-[180px] w-auto sm:max-h-[240px] md:max-h-[300px]"
            data-intercom-target="sso-access-ended-illustration"
          />
        </div>

        {/* Title */}
        <h1
          className="mb-3 px-4 text-center text-2xl font-semibold leading-tight text-black md:mb-4 md:text-[32px] md:leading-[36px]"
          data-intercom-target="sso-access-ended-title"
        >
          <T kind="error_page.access_ended.title" />
        </h1>

        {/* Message */}
        <p
          className="mb-6 w-full max-w-[90%] px-4 text-center text-sm font-normal leading-relaxed text-black md:mb-8 md:w-[588px] md:text-[14px] md:leading-[24px]"
          data-intercom-target="sso-access-ended-message"
        >
          <T kind="error_page.access_ended.message" />
        </p>

        {/* Button */}
        <div className="flex w-full max-w-[90%] flex-col items-center gap-4 px-4 sm:w-[280px] md:w-[250px]">
          <button
            onClick={handleVisitWebsite}
            className="flex w-full items-center justify-center rounded-md border border-solid border-teal-600 bg-white px-5 py-2.5 text-sm font-semibold text-teal-600 transition-colors hover:bg-teal-50 md:text-[14px]"
            data-intercom-target="sso-access-ended-visit-button"
          >
            <T kind="error_page.access_ended.visit_website" />
          </button>
        </div>
      </div>
    </div>
  );
});

export default SSOAccessEnded;
